import { useEffect } from 'react';

import { IframeOpener } from '../../vanillaComponent/iframe-opener';
// import { AffordabilityBanner } from '../../vanillaComponent/AffordabilityBanner';
import { AffordabilityBanner } from '../../vanillaComponent/affordability-banner/AffordabilityBanner';

function CreditScoreWidget() {
  useEffect(() => {
    const openIframeContainer = document.getElementById('open-iframe');

    if (openIframeContainer && !openIframeContainer.querySelector('[id^="open-iframe-button"]')) {
      const iframeUrl = `${
        import.meta.env.VITE_HOST_URL
      }/credit-score/66796981d8097d001d9a63e0/v2?dealership=Auto401&lang=en&zipCode=N3H1X3&themeName=theme1`; // Replace with the actual URL

      // const widgetData = {
      //   containerSelector: 'open-iframe',
      //   buttonName: 'Credit Score',
      //   iframeUrl: iframeUrl,
      //   customClassName: 'custom-class-name',
      // };

      // // new IframeOpener(widgetData);

      const widgetData = {
        // containerSelector: 'open-iframe',
        // buttonName: 'Free Trade-In Estimate',
        token: 'eVcweWJyRHRDUkhQb0JjZWpMdFFMcndK', // 'eURWNzJ0dENOTFJCTkJLVjVQVkFNNjJI', // 'eVcweWJyRHRDUkhQb0JjZWpMdFFMcndK',
        // iframeUrl: iframeUrl,
        type: 'button',
        version: '1.0',
        // customClassName: 'custom-class-name',
        module: 'credit-score',
      };

      new IframeOpener(widgetData).render(openIframeContainer);
    }

    const affordabilityContainer = document.getElementById('affordability-container-new');

    if (affordabilityContainer && affordabilityContainer.children.length === 0) {
      const widgetData = {
        // bgColor: '#ff99ff',
        // language: 'en',
        // zipCode: 'N3H1X3',
        // leadSourceId: '622f933a625b980012690710', //'6679693cd8097d001d9a63d8',
        // dealershipName: 'Auto401',
        // customClassName: 'custom-class-name',
        // version: 'v2',
        // associateDealerCode: 44444,

        token: 'eVcweWJyRHRDUkhQb0JjZWpMdFFMcndK', // 'S2JreTFCVW1UWFRqMEF5Rjd2VWowQk9B', // 'eURWNzJ0dENOTFJCTkJLVjVQVkFNNjJI', // 'eVcweWJyRHRDUkhQb0JjZWpMdFFMcndK', // 'Z1BJRUZuS2U0dUl6UnNua2FMSGw4OGdm',
        type: 'banner',
        version: '1.0',
        module: 'credit-score',
        design: 'equifax',
        // theme: 'theme2',
      };

      const banner = new AffordabilityBanner(widgetData);
      banner.render(affordabilityContainer);

      // Additional logic or configuration for the searchComponent
    }

    return () => {};
  }, []);

  return (
    <>
      <div id='affordability-container-new'></div>

      {/* <div style={{ position: 'absolute', top: '60%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <div id='open-iframe'></div>
      </div> */}

      <div
        style={{
          position: 'absolute',
          top: '60%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <div id='open-iframe'></div>
      </div>
    </>
  );
}

export default CreditScoreWidget;
